<template>
  <div class="dialog">
    <div class="dialogWrapper">
      <!-- Root element of PhotoSwipe. Must have class pswp. -->
      <div class="pswp common" tabindex="-1" role="dialog" aria-hidden="true">

        <!-- Background of PhotoSwipe.
             It's a separate element as animating opacity is faster than rgba(). -->
        <div class="pswp__bg"></div>

        <!-- Slides wrapper with overflow:hidden. -->
        <div class="pswp__scroll-wrap">

          <!-- Container that holds slides.
              PhotoSwipe keeps only 3 of them in the DOM to save memory.
              Don't modify these 3 pswp__item elements, data is added later on. -->
          <div class="pswp__container">
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
          </div>

          <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
          <div class="pswp__ui pswp__ui--hidden">

            <div class="pswp__top-bar">

              <!--  Controls are self-explanatory. Order can be changed. -->

              <div class="pswp__counter"></div>

              <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

              <button class="pswp__button pswp__button--share" title="Share"></button>

              <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>

              <!--<button class="pswp__button pswp__button&#45;&#45;zoom" title="Zoom in/out"></button>-->
              <i class="pswp_button-icon icon-zoomOut" @click="zoom(1)"></i>
              <i class="pswp_button-icon icon-zoomIn" @click="zoom(-1)"></i>
              <i class="pswp_button-icon icon-rotate" @click="rotate"></i>

              <!-- Preloader demo http://codepen.io/dimsemenov/pen/yyBWoR -->
              <!-- element will get class pswp__preloader--active when preloader is running -->
              <div class="pswp__preloader">
                <div class="pswp__preloader__icn">
                  <div class="pswp__preloader__cut">
                    <div class="pswp__preloader__donut"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
              <div class="pswp__share-tooltip"></div>
            </div>

            <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
            </button>

            <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
            </button>

            <div class="pswp__caption">
              <div class="pswp__caption__center"></div>
            </div>

          </div>

        </div>

      </div>
    </div>
  </div>
</template>
<script>
import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "src/components/dialog-image-preview-common/photoswipe-ui-default";
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
  mounted() {},
  data() {
    return {
      gallery: null,
      zoomNumber: 0,
      rotateDeg: 0
    };
  },
  methods: {
    ...mapMutations({
      setSomeRootState: "setImgForPreview"
    }),
    init(items) {
      var pswpElement = document.querySelectorAll(".pswp.common")[0];

      var options = {
        index: this.imgPreviewStartIndex, // start at first slide
        closeOnScroll: false,
        closeOnVerticalDrag: true,
        escKey: true,
        pinchToClose: true,
        tapToClose: true,
        clickToCloseNonZoomable: true,
        mouseUsed: false,
        mainClass: "myPreview",
        bgOpacity: 0.5,
        getDoubleTapZoom: function(isMouseClick, item) {
          return item.initialZoomLevel;
        }
      };

      // Initializes and opens PhotoSwipe

      this.gallery = new PhotoSwipe(
        pswpElement,
        PhotoSwipeUI_Default,
        items,
        options
      );
      this.gallery.listen("close", () => {
        this.setSomeRootState({ needShowImgPreviewCommon: false });
      });
      var self = this;
      this.gallery.listen("gettingData", function(index, item) {
        if (!item.w || !item.h || item.w < 1 || item.h < 1) {
          const img = new Image();
          img.onload = function() {
            item.w = this.width;
            item.h = this.height;
            self.gallery.updateSize(true);
          };
          img.src = item.src;
        }
      });

      this.gallery.listen("afterChange", () => {
        this.zoomNumber = 0;
        this.rotateDeg = 0;
      });
      this.gallery.init();
    },
    zoom(flag) {
      if (flag === 1) {
        // 放大
        this.zoomNumber += 0.5;
      } else {
        // 缩小
        this.zoomNumber -= 0.5;
        if (this.zoomNumber < 0) {
          this.zoomNumber = 0;
        }
      }
      this.gallery.zoomTo(
        this.zoomLevel + this.zoomNumber,
        {
          x: this.gallery.viewportSize.x / 2,
          y: this.gallery.viewportSize.y / 2
        },
        500,
        false
      );
    },
    rotate() {
      var img = this.gallery.currItem.container.lastChild;

      var deg = img.style.transform.replace(/^rotate\(|deg\)$/g, "");
      if (deg !== "") {
        // 如果当前已经是旋转状态，则继续旋转
        this.rotateDeg = parseInt(deg);
      }

      this.rotateDeg += 90;
      img.style.transitionDuration = "0.3s";
      img.style.transform = "rotate(" + this.rotateDeg + "deg)";
    }
  },
  computed: {
    ...mapState({
      previewImg: "previewImg",
      imgPreviewStartIndex: "imgPreviewStartIndex"
    }),
    ...mapGetters({
      imgsNeedToPreview_Items: "imgsNeedToPreview_Items"
    }),
    zoomLevel() {
      return this.gallery.getZoomLevel();
    }
  },
  watch: {
    "previewImg.needShowImgPreviewCommon"(val) {
      if (val) {
        this.init(this.imgsNeedToPreview_Items);
      }
    }
  }
};
</script>
<style scoped>
.dialog {
  /*position: fixed;*/
  /*width: 1356px;*/
  /*height: 100%;*/
  /*top: 28px;*/
  /*z-index: 99999;*/
  /*!*background-color: #2f2f2f;*!*/
  /*!*background-color: transparent;*!*/
  /*background-color: rgba(47, 47, 47, 0.5);*/
}

.dialogWrapper {
  position: fixed;
  width: 1240px;
  height: 714px;
  top: 5%;
  left: 50%;
  transform: translateX(-50%);
  margin: 0 auto;
  z-index: 9999;
}
</style>
<style>
.pswp.common .pswp__zoom-wrap {
  position: absolute;
}
.pswp--zoom-allowed .pswp__img {
  /* cursor: -webkit-zoom-in; */
  cursor: default;
  /* cursor: zoom-in; */
}

.pswp.common .pswp__img {
  left: 0;
  right: 0;
}

.pswp_button-icon {
  display: inline-block;
  width: 44px;
  height: 44px;
  border: 0;
  padding: 0;
  margin: 0;
  float: right;
  background-position: center !important;
  cursor: pointer;
}

.icon-zoomIn {
  background: url("./zoomIn.svg") 0 0 no-repeat;
  background-size: 21px 20px;
}

.icon-zoomOut {
  background: url("./zoomOut.svg") 0 0 no-repeat;
  background-size: 21px 20px;
}

.icon-rotate {
  background: url("./rotate.svg") 0 0 no-repeat;
  background-size: 18px 18px;
}
</style>
<style src="./default-skin/default-skin.css" scoped>
</style>
<style src="./photoswipe.css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/dialog-image-preview-common/dialogImagePreviewCommon.vue